import { IOrganizationNode } from '../models/organization-chart.types';

export const DEFAULT_ORGANIZATION_CHART: IOrganizationNode = {
  label: 'John Doe',
  imageUrl: 'assets/images/profile/john-doe.jpg',
  title: 'IT Manager',
  currentPhase: 3,
  selected: true,
  level: '',
  score: 2,
  id: 4,
  sk_user: '1',
  email: 'john.doe@astrazeneca.com',
  prid: 'kqss336',
  children: [
    {
      label: 'Jane Smith',
      imageUrl: 'assets/images/profile/jane-smith.jpg',
      title: 'Software Engineer',
      currentPhase: 1,
      selected: true,
      level: '',
      score: 2,
      id: 1,
      sk_user: '2',
      email: 'jane.smith@astrazeneca.com',
      prid: 'kqss336',
    },
    {
      label: 'Will Brown',
      imageUrl: 'assets/images/profile/jane-smith.jpg',
      title: 'Software Engineer',
      currentPhase: 2,
      selected: true,
      level: '',
      score: 2,
      id: 2,
      sk_user: '3',
      email: 'will.brown@astrazeneca.com',
      prid: 'kqss336',
    },
    {
      label: 'Sarah Williams',
      imageUrl: 'assets/images/profile/sarah-williams.jpg',
      title: 'Software Engineer',
      currentPhase: 4,
      selected: true,
      level: '',
      score: 2,
      id: 3,
      sk_user: '4',
      email: 'sarah.williams@astrazeneca.com',
      prid: 'kqss336',
    },
  ],
};
